//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModuleTitle from "@/pccomponents/ModuleTitle";
import formValidate from "@/js/formValidate";

export default {
  name: "roleload",
  components: {
    ModuleTitle,
  },
  props:{
    roleid:{
      type:String,
      default:""
    },
  },
  data() {
    return {
      formTipArray:[],//规则校验弹出框的值
      aFormValidateTip:[],//校验所需
      search:"",
      sysflag:[],//是否系统内置角色的下拉框参数
      suitflag:[],//是否适用整个地区的下拉框参数
      responseData:{
        record:{},
        userlist:[],
        deptlist:[],
        edititems:'',
        notNullItems:''
      },//保存的数据

      testPersonIds:'',
      testDepartIds:'',

      editItemShow:true,//控制行项是否可新增删除
      ulstyle:2,//控制整体ul的列数

      moduleTitle: this.$t('travelDetail.contentTitle'),
      moduleTitle2:this.$t('travelDetail.contentLine'),
      moduleTitle3:this.$t('travelDetail.contentFlow'),

      rules: {},
      flowList: [],//流程数据
      flowsysid:'FLOW',
    };
  },
  methods: {
    /**
     * 表单初始化
     */
    async queryInfo() {
      console.log('2019年11月27日16:05:20 roleload.vue[表单初始化]——[null] :',null);
      let url = "";
      if(this.roleid==''){
        url = "role/loadAdd";
      }else{
        url = "role/load";
      }
      
      let params = {
        roleid:this.roleid,
        flowsysid:this.flowsysid,
      };
      await this.axios.post(url, params).then(({ data }) => {
        console.log('2019年12月06日10:44:24 roleload.vue[描述]——[data] :',data);
        //为可编辑域赋值
        this.responseData.edititems=data.data.edititems;
        //为表单校验规则赋值
        formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
        this.responseData.notNullItems=data.data.notNullItems;

        //主表单赋值
        this.responseData.record=data.data.record;
        //暂时不确定外键使用areacode还是areaid无法获取
        this.responseData.record.applyareacode=data.data.applyareacode;//将后台要取的地址放入主表单
        this.responseData.record.delRowuserIDs=[];
        this.responseData.record.delRowdeptIDs=[];
        
        //为人员信息赋值
        if(this.isNotNullOrEmpty(data.data.userlist)){
          this.responseData.userlist=data.data.userlist;
        }

        //为部门信息赋值
        if(this.isNotNullOrEmpty(data.data.deptlist)){
          this.responseData.deptlist=data.data.deptlist;
        }
      });
    },
    /**
     * 保存信息
     */
    async saveData(){
      let isValidateSucc = formValidate.checkFormSave4NotFlow(this,'responseData');
      if(isValidateSucc){
        //去除空行
        this.delNullLineByColumn(this.responseData,'userlist','username');
        this.delNullLineByColumn(this.responseData,'deptlist','deptname');

        let url = "role/save";
        let params = this.responseData;
        params.flowsysid=this.flowsysid;
        await this.axios.post(url, params).then(({ data }) => {
          if(data.code=='1'){
            console.log('2019年12月02日16:00:25 roleload.vue[保存成功]——[null] :',null);
          }else{
            this.tipRight('失败','保存失败','error');
          }

        }).catch(function(error){
          console.log(error)//错误处理 相当于error
          this.tipRight('失败','保存失败','error');
        })
      }
      return isValidateSucc;
    },
    /**
     * 更新角色人员信息
     */
    updateRoleUser(params){
      //删除当前行
      if(params.returnData.length!=0){
        this.responseData.record.delRowuserIDs.push(this.responseData.userlist[params.rowindex].roleuserid);
        this.responseData.userlist.splice(params.rowindex,1);
      }

      for(let i=params.returnData.length-1;i>=0;i--){
        let obj={};
        obj['areaname']=params.returnData[i]['areaname'];
        obj['userid']=params.returnData[i]['account'];
        obj['username']=params.returnData[i]['username'];
        obj['deptname']=params.returnData[i]['deptname'];
        obj['deptid']=params.returnData[i]['deptid'];
        obj['areacode']=params.returnData[i]['areacode'];

        this.responseData.userlist.splice(params.rowindex,0,obj);
      }
      //去除空行
      this.delNullLineByColumn(this.responseData,'userlist','username');
    },
    /**
     * 更新角色部门信息
     */
    updateRoleDept(params){
      //删除当前行
      if(params.returnData.length!=0){
        this.responseData.record.delRowdeptIDs.push(this.responseData.deptlist[params.rowindex].roledeptid);
        this.responseData.deptlist.splice(params.rowindex,1);
      }

      for(let i=params.returnData.length-1;i>=0;i--){
        let obj={};
        obj['areaname']=params.returnData[i]['deptname'];//获取地区名称，暂为deptname，后续需要修改
        obj['deptname']=params.returnData[i]['deptname'];
        obj['deptid']=params.returnData[i]['deptid'];
        obj['areacode']=params.returnData[i]['areacode'];
        
        this.responseData.deptlist.splice(params.rowindex,0,obj);
      }
      //去除空行
      this.delNullLineByColumn(this.responseData,'deptlist','deptname');
    },
  },
  created() {
    //初始化下拉框
    var requestJsonData = []; 
    let paramArray1 = {
      showcode:'sysflag',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"YESORNO","paras1":"1"}
    };
    let paramArray2 = {
      showcode:'suitflag',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"YESORNO","paras1":"1"}
    };
    requestJsonData.push(paramArray1);
    requestJsonData.push(paramArray2);
    this.initDropDown(this,requestJsonData);
    
    console.log('created');
    this.queryInfo();
  },
  mounted(){
  },
  destroyed(){
  }
};



// WEBPACK FOOTER //
// ./src/pcpage/ptooa/permission/roleload.vue